import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const Selector = ({ value, onChange, options, label, className, fullWidth }) => {
    return (
        <FormControl fullWidth={fullWidth} className={className}>
            <InputLabel id={`select-label-${label}`}>{label}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={onChange}
            >
                {options.map(option => (
                    <MenuItem
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default Selector;